export default "__VITE_ASSET__TaJuBHSu__"